export default "__VITE_ASSET__fe6950da__"